import { format, parse } from 'date-fns';

/**
 * Converts a date string from the required display format (as per design system)
 * to a value that the backend can understand (ISO format)
 *
 * @param dateString - The date string to be converted
 */
export default function digestDateForBackend(dateString: string): string {
  try {
    const parsedDate = format(
      parse(dateString, 'dd/MM/yyyy', new Date()),
      'yyyy-MM-dd',
    );
    return `${parsedDate}T00:00:00Z`;
  } catch (e) {
    return '';
  }
}
